module.exports = __webpack_public_path__ + "static/media/bragantino.51066b5c.svg";